import { Link } from "react-router-dom"
import navLogo from '../../../assets/images/logo.webp'

export default function SaleCta () {

return (

    <div className='w-full h-full  items-center justify-between  bg-black/80 backdrop-blur py-2 px-5 border border-yellow-500/10 flex sticky top-1 z-40 rounded'  >
                    <Link to={'/'}>
                        <div className='flex flex-col items-center justify-center'>
                            <img src={navLogo} alt="" className='w-10 h-10' />
                            <p className='font-logo text-yellow-500 text-sm'>Phoenix </p>
                        </div>
                    </Link>
                    <div className='w-full flex justify-center items-center gap-10'>
                        <div className='flex flex-col gap-2'>
                            <p className='text-sm md:text-2xl text-yellow-500 font-bold'>Refer and Earn  🥳 ! </p>
                            {/* <p className='tracking-wide text-yellow-500 font-bold text-xs md:text-md'>Enjoy 5% Solana Reward each referral ! instant withdrawl 🥳 ! </p> */}
                        </div>
                        <Link to={'/dashboard'} className="py-1 w-max px-2 hover:text-black text-xxs bg-yellow-500 hover:bg-green-500 text-black rounded"  >Join !</Link>

                    </div>
                </div>
)



}